import { memo } from "../../../shared/memoization";

interface ICalculateRange {
  page: number;
  recordsPerPage?: number;
  totalRecords: number;
}

export const calculateRange = ({
  page = 1, //Defaults.  Should setup a config.
  recordsPerPage = 10, //Set it to default to 10 if this property does not exist on props
  totalRecords = 10 //The total number of records that will be display
}: any) => {
  //default values for the starting page view
  let start = 1,
    end = recordsPerPage,
    //use function currying to invoke the method memo returns
    totalPages = memo((a: number, b: number) => Math.ceil(a / b))(
      totalRecords,
      recordsPerPage
    ),
    count = recordsPerPage;

  //Ensure they are numbers not strings
  page = +page;
  recordsPerPage = +recordsPerPage;
  totalRecords = +totalRecords;

  /*
            to calculate start/end on a middle page
            start = ((page -1) * #Recordsper page) + 1
            end = count (profile count) + (#Recordsper page * (page -1 * #Recordsper))

            to calculate start/end on the last page
            start = (totalRecords - count) + 1
            end = count (profile count) + (#Recordsper page * (page -1))

            ie. 102 records
            start = (102 - 2) + 1 = 100
            end = 2 + (50 * (3 -1)) = 102

            ie. 150 records
            start = (150 - 50) + 1 = 101
            end = 50 + (50 * (3 -1)) = 150

        */

  start = (page - 1) * recordsPerPage + 1;
  if (page > 1 && page < totalPages) {
    //This is a middle page view
    end = count + recordsPerPage * (page - 1);
  } else if (page === totalPages) {
    //This is the last page view
    end = totalRecords;
  }
  return {
    totalPages,
    start,
    end
  };
};
export const calcCurrentPage = (
  currentPage: number,
  totalPages: number,
  direction: number = 1
) => {
  const targetPage = currentPage + direction;

  //This handles whether the request exceeds the totalPages that can be viewed
  let page = targetPage > totalPages ? 1 : targetPage;

  //This handles whether the requested page index is less than 1.
  page = page < 1 ? totalPages : page;

  return page;
};
try {
    // @ts-ignore
    calculateRange.displayName = "calculateRange";
    // @ts-ignore
    calculateRange.__docgenInfo = { "description": "", "displayName": "calculateRange", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Paging/utils.ts#calculateRange"] = { docgenInfo: calculateRange.__docgenInfo, name: "calculateRange", path: "src/shared/components/Paging/utils.ts#calculateRange" };
}
catch (__react_docgen_typescript_loader_error) { }